module.exports = __webpack_public_path__ + "static/media/submitted-offer.41e777d8.svg";